import { FormEvent, useState } from "react";
import { Mail, Phone, Pin } from "../icons";
import { sendForm } from "../submit";

export function Contact() {
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    setSending(true);
    setError("");
    try {
      await sendForm("Contact message", form);
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not send.");
    } finally {
      setSending(false);
    }
  }
  return (
    <section className="wrap contact section">
      <div>
        <h1>Get in touch</h1>
        <p className="soft">A warm hello is the beginning of everything. Send a message and I'll respond within 24 hours.</p>
        {sent ? (
          <div className="success sage">
            <h2 style={{ fontSize: "1.5rem" }}>Message received</h2>
            <p className="soft">Thank you — I'll be in touch soon.</p>
          </div>
        ) : (
          <form className="form" onSubmit={submit}>
            <div className="fields">
              <input name="name" required placeholder="Your name" aria-label="Your name" />
              <input name="email" required type="email" placeholder="Email" aria-label="Email" />
            </div>
            <select name="topic" aria-label="Topic" defaultValue="General enquiry">
              <option>General enquiry</option>
              <option>Booking support</option>
              <option>Media / speaking</option>
              <option>Other</option>
            </select>
            <textarea name="message" required placeholder="Your message" aria-label="Your message" rows={5} />
            <input className="botcheck" type="checkbox" name="botcheck" tabIndex={-1} aria-hidden="true" />
            {error && <p className="form-error">{error}</p>}
            <button className="btn" type="submit" disabled={sending}>{sending ? "Sending…" : "Send message"}</button>
          </form>
        )}
      </div>
      <aside className="aside peach stack">
        <h2 style={{ fontSize: "1.5rem" }}>Reach Out</h2>
        <div className="reach"><Mail /><div><small>Email</small>warmnestcounselling@gmail.com</div></div>
        <div className="reach"><Phone /><div><small>Phone</small>081 472 7220</div></div>
        <div className="reach"><Pin /><div><small>Location</small>100% online sessions — nationwide South Africa</div></div>
      </aside>
    </section>
  );
}
